// offerings
export const DISCOUNT_DURATION_UNIT_MONTH = 'm';
export const DISCOUNT_DURATION_UNIT_WEEK = 'w';
export const DISCOUNT_TYPE_INTRO_PRICING = 'introPricing';
export const DISCOUNT_TYPE_PERCENTAGE = 'percentage';
export const DISCOUNT_TYPE_STATIC_SKUS = 'staticSkus';
export const DISCOUNT_TYPE_SUB_OFFER = 'subOffer';

export const OFFER_TYPE_DISCOUNT = 'DISCOUNT';
export const OFFER_TYPE_INTRO_PRICE = 'INTRO_PRICE';
export const OFFER_TYPE_REGULAR = 'REGULAR';
export const OFFER_TYPE_SUB_OFFER = 'SUB_OFFER';

export const SUB_OFFER_TYPE_CUSTOMER_SUPPORT = 'customerSupport';
export const SUB_OFFER_TYPE_DOWNGRADE = 'downgrade';
export const SUB_OFFER_TYPE_LOYALTY = 'loyalty';
export const SUB_OFFER_TYPE_RETENTION = 'retention';
export const SUB_OFFER_TYPE_SAVE = 'save';
export const SUB_OFFER_TYPE_UPGRADE = 'upgrade';
export const SUB_OFFER_TYPE_WIN_BACK = 'winback';

export const DISCOUNTED_OFFER_TYPES = [
  OFFER_TYPE_INTRO_PRICE,
  OFFER_TYPE_DISCOUNT,
  OFFER_TYPE_SUB_OFFER,
];

export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_DURATION = 0;
export const DEFAULT_SUBSCRIPTION_TERMS = 1;
export const DEFAULT_PRICE = 0;
export const DEFAULT_DISCOUNT = 0;
export const DEFAULT_AMOUNT = 0;
export const DEFAULT_TAX_RATE = 0;
